export default {
  Found: 1,
  NotFound: 2,
  IsLoading: 3,
  Broken: 4,
};
